import styles from './_dealer-reports-grid.module.scss';
import { GenericGrid } from '@amsanalytics/react-shared-library';
import { DealerReport } from '../../../../Models/DealerReport';
import { InternalReportLinkCell } from '../../../Controls/ExternalLink/ExternalLink';
import { SvgIcon } from '@progress/kendo-react-common';

import * as svgIcons from '@progress/kendo-svg-icons';
import { formatMonthYear } from '../../../../Helpers/Utilities';
import { AppState } from '../../../../Store/rootReducer';
import { useSelector } from 'react-redux';
export interface DealerReportsGridProps {
  dealerReports: DealerReport[];
  canCreateReportInputData: boolean;
  onOpenReportInputDataEntry: (item: DealerReport) => void;
  onViewComposite: (dealerReport: DealerReport) => void;
  onCreateItem: () => void;  
  headerComponent?: React.ReactNode;
}


export default function DealerReportsGrid (props:  DealerReportsGridProps) {
  const businessTypes = useSelector((state: AppState) => state.library.businessTypes);
  const componentProps = props;
  return (
    <div className={styles.dealerReportsGridContainer}>
      <GenericGrid<DealerReport>
        headerComponent={props.headerComponent}
        disableEditing={true}
        disableAdding={!props.canCreateReportInputData}
        useIconButtons={true}
        disableGrouping={true}
        itemName='Dealer Inputs'                
        itemNameStyle={{ color: '#d95137'}}
        items={props.dealerReports.map((dr: DealerReport) => {
          return {
            ...dr,
            period: formatMonthYear(dr.month, dr.year),
            date: new Date(dr.date),
            type: businessTypes.find(bt => bt.id === dr.businessTypeId)?.name ?? '',
          }
        })}
        selectedField={'selected'}
        onOpenItemEditor={(item?: DealerReport) => {
          componentProps.onCreateItem();
        }}
        columns={[
          { field: '', title: ' ', cell: (props: any) => <InternalReportLinkCell 
            {...props} 
            icon={<span style={{color: '#d95137', fontSize: '25px', cursor: 'pointer'}} className="k-icon k-font-icon k-i-track-changes" />}
            onReportClick={(report: DealerReport) => {
              componentProps.onOpenReportInputDataEntry(report);
            }} />, 
            width: '70px', preventFiltering: true, preventSorting: true
          },          
          { field: "period", title: "Period", width: '130px', preventFiltering: true },
          { field: "status", width: "175px", title: "Status" },
          { field: "date", width: "180px", title: "Date", format: "{0:d}" },
          { field: "type", title: "Type"},
          { field: "dealerName", title: "Dealer" },
          { field: '', headerClassName: styles.reportsCompositeColumnHeader, columnClassName: styles.reportIconCell, title: 'Composite', cell: (props: any) => <InternalReportLinkCell 
            {...props} 
            hideCellContents={props.dataItem.status !== 'Submitted'}
            icon={
              <SvgIcon icon={svgIcons['fileReportIcon']}  style={{color: 'green', cursor: 'pointer', padding: '0px', width: 'calc(14.5px * 2)', height: 'calc(14.5px * 2)'}} />
              // <div style={{ position: 'relative', cursor: 'pointer' }}>
              //   <ArticleIcon style={{ fontSize: '35px', color: '#b2b2b2' }} />
              //   <CalculateIcon style={{ color: 'green', fontSize: '20px', position: 'absolute', left: '16px', top: '0px', }} />
              // </div>
            }
            onReportClick={(report: DealerReport) => {
              componentProps.onViewComposite(report);
            }} />, 
            width: '100px', preventFiltering: true, preventSorting: true
          }

        ]}
      />      
    </div>
  );
}
